import React, { useEffect, useState } from "react";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import { Box, CircularProgress } from "@mui/material";

const ClinicianSocialMedia = ({
  formik,
  getSocialMedia,
  loader,
  socialMediaStartLoader,
}: {
  formik: any;
  getSocialMedia: any;
  loader: any;
  socialMediaStartLoader: any;
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchSocialMedia = async () => {
      setOpen(socialMediaStartLoader);

      if (
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleFacebookLink !== undefined &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleFacebookLink !== null &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleFacebookLink !== ""
      ) {
        formik.setFieldValue(
          "facebookLink",
          getSocialMedia?.additionalDetails.socialMediaDetails.eleFacebookLink
        );
      }
      if (
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleTwitterLink !== undefined &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleTwitterLink !== null &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleTwitterLink !== ""
      ) {
        formik.setFieldValue(
          "twitterLink",
          getSocialMedia?.additionalDetails.socialMediaDetails.eleTwitterLink
        );
      }
      if (
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleLinkedInLink !== undefined &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleLinkedInLink !== null &&
        getSocialMedia?.additionalDetails?.socialMediaDetails
          ?.eleLinkedInLink !== ""
      ) {
        formik.setFieldValue(
          "linkedInLink",
          getSocialMedia?.additionalDetails.socialMediaDetails.eleLinkedInLink
        );
      }
      setOpen(false);
    };

    fetchSocialMedia();

    // eslint-disable-next-line
  }, [getSocialMedia, loader, socialMediaStartLoader]);

  return (
    <CommonCard>
      <Typography variant="h6" className={globalClasses.typography}>
        Social Media Link
      </Typography>
      {open && (
        <Box className={globalClasses.loader}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {!open && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InputField
              id="facebookLink"
              label="Facebook Link"
              name="facebookLink"
              inputvalues={formik.values.facebookLink}
              errormessage={
                formik.touched.facebookLink &&
                Boolean(formik.errors.facebookLink)
              }
              message={
                formik.touched.facebookLink && formik.errors.facebookLink
              }
              changeevent={formik.handleChange}
              blurevent={formik.handleBlur}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputField
              id="twitterLink"
              label="Twitter Link"
              name="twitterLink"
              inputvalues={formik.values.twitterLink}
              errormessage={
                formik.touched.twitterLink && Boolean(formik.errors.twitterLink)
              }
              message={formik.touched.twitterLink && formik.errors.twitterLink}
              changeevent={formik.handleChange}
              blurevent={formik.handleBlur}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <InputField
              id="linkedInLink"
              label="Linkedin Link"
              name="linkedInLink"
              inputvalues={formik.values.linkedInLink}
              errormessage={
                formik.touched.linkedInLink &&
                Boolean(formik.errors.linkedInLink)
              }
              message={
                formik.touched.linkedInLink && formik.errors.linkedInLink
              }
              changeevent={formik.handleChange}
              blurevent={formik.handleBlur}
            />
          </Grid>
        </Grid>
      )}
    </CommonCard>
  );
};

export default ClinicianSocialMedia;
